import React, { Component } from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import Loading from "../shared/Loading";
import PageHeading from '../shared/PageHeading';
import ProjectResources from './ProjectResources';
import ProjectSummary from './ProjectSummary';
import ProjectTabs from './ProjectTabs';

import { getProject } from "../data/dataCIMToolkit";
import AddProject from "./AddProject";
import DeleteProject from "./DeleteProject";
import PageHeadingLink from "../shared/PageHeadingLink";

class Project extends Component {
  state = {
    isLoading: true,
    isEditingProject: false,
    isDeletingProject: false,
    projectData: {},
    sites: [],
    resources: [],
    currentTab: 'summary'
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    if (this.context.token !== "") {
      await this.loadProjectData();
    }
    await this.setState({isLoading: false});
  };
  toggleDeleteProjectConfirmation = async id => {
    await this.setState({isDeletingProject: !this.state.isDeletingProject});
  };
  editProject = async data => {
    this.toggleEditProjectForm();
  };
  loadProjectData = async () => {
    await this.setState({isLoading: true});
    const projectData = await getProject(this.props.match.params.id, this.context.token);
    await this.setState({
      isLoading: false,
      projectData: projectData.data[0]
    });

    //console.log("Project data", projectData);
  };
  setCurrentTab = async tab => {
    await this.setState({currentTab: tab});
  };
  toggleEditProjectForm = async () => {
    await this.setState({
      isEditingProject: !this.state.isEditingProject
    });
  };
  render() {
    if (this.state.isLoading) {
      return (
        <Loading/>
      );
    }
    else if (this.state.isDeletingProject) {
      return (
        <AppContent>
          <DeleteProject
            projectData={this.state.projectData}
            toggleDeleteProjectConfirmation={this.toggleDeleteProjectConfirmation}
          />
        </AppContent>
      )
    }
    else if (this.state.isEditingProject) {
      return  (
        <AppContent>
          <AddProject
            projectData={this.state.projectData}
            editProject={this.editProject}
            closeForm={this.toggleEditProjectForm}
            loadProjectData={this.loadProjectData}
          />
        </AppContent>
      )
    }
    else {
      return (
        <AppContent>
          <PageHeading small>
            <PageHeadingLink to={`/projects`}>My Projects</PageHeadingLink> > {this.state.projectData.name}</PageHeading>
          <ProjectTabs projectData={this.state.projectData} currentTab={this.state.currentTab} setCurrentTab={this.setCurrentTab} />
          {
            this.state.currentTab === 'summary'
            &&
            <ProjectResources
              isNewFileSizeReady={this.context.isNewFileSizeReady}
              projectData={this.state.projectData}
              loadProjectData={this.loadProjectData}
            />
          }
          {
            this.state.currentTab === 'details'
            &&
            <ProjectSummary
              projectData={this.state.projectData}
              toggleEditProjectForm={this.toggleEditProjectForm}
              editProject={this.editProject}
              toggleDeleteProjectConfirmation={this.toggleDeleteProjectConfirmation}
            />
          }
        </AppContent>
      );
    }
  }
}

export default Project;
